import React from 'react'

interface PreferencesIconProps {
    className?: string
    size?: number
    variant?: 'default' | 'active' | 'hover'
}

export function PreferencesIcon({
    className = '',
    size = 24,
    variant = 'default'
}: PreferencesIconProps) {
    const colors = {
        default: {
            primary: '#94a3b8',
            secondary: '#64748b',
            accent: '#fb2ba9',
            glow: 'rgba(251, 43, 169, 0.2)'
        },
        active: {
            primary: '#fb2ba9',
            secondary: '#e91e8c',
            accent: '#fb2ba9',
            glow: 'rgba(251, 43, 169, 0.4)'
        },
        hover: {
            primary: '#cbd5e1',
            secondary: '#94a3b8',
            accent: '#fb2ba9',
            glow: 'rgba(251, 43, 169, 0.3)'
        }
    }

    const c = colors[variant]

    return (
        <>
            <style>{`
        /* LEFT SLIDER: Pink Blink + Slide Down */
        @keyframes adjust-left {
          0% { transform: translateY(0); fill: ${c.secondary}; }
          30% { transform: translateY(6px); fill: #CC339F; }
          100% { transform: translateY(4px); fill: ${c.secondary}; }
        }
        
        /* MIDDLE SLIDER: Purple Blink + Slide Up */
        @keyframes adjust-middle {
          0% { transform: translateY(0); fill: ${c.secondary}; }
          40% { transform: translateY(-6px); fill: #6600FF; }
          100% { transform: translateY(-4px); fill: ${c.secondary}; }
        }
        
        /* RIGHT SLIDER: Cyan Blink + Slide Down & Stay */
        @keyframes adjust-right {
          0% { transform: translateY(0); fill: ${c.primary}; }
          50% { transform: translateY(4px); fill: #00FFC0; }
          100% { transform: translateY(2px); fill: #00FFC0; }
        }

        .prefs-hover .knob-left {
          animation: adjust-left 1.2s ease-in-out forwards;
        }

        .prefs-hover .knob-middle {
          animation: adjust-middle 1.2s ease-in-out 0.1s forwards;
        }

        .prefs-hover .knob-right {
          animation: adjust-right 1.2s ease-in-out 0.2s forwards;
        }
      `}</style>

            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`${className} ${variant === 'hover' ? 'prefs-hover' : ''}`}
            >
                {/* Active Glow */}
                {variant === 'active' && (
                    <circle cx="12" cy="12" r="10" fill={c.glow} opacity="0.6" />
                )}

                {/* Vertical Tracks */}
                <rect x="5" y="5" width="2" height="14" rx="1" fill={c.secondary} opacity="0.15" />
                <rect x="11" y="5" width="2" height="14" rx="1" fill={c.secondary} opacity="0.15" />
                <rect x="17" y="5" width="2" height="14" rx="1" fill={c.secondary} opacity="0.15" />

                {/* Slider 1 (Left) */}
                <rect
                    className="knob-left"
                    x="3" y="6" width="6" height="4" rx="1.5"
                    fill={c.secondary}
                    stroke={variant === 'active' ? c.accent : 'transparent'}
                    strokeWidth="1.2"
                />

                {/* Slider 2 (Middle) */}
                <rect
                    className="knob-middle"
                    x="9" y="14" width="6" height="4" rx="1.5"
                    fill={c.secondary}
                    stroke={variant === 'active' ? c.accent : 'transparent'}
                    strokeWidth="1.2"
                />

                {/* Slider 3 (Right) - Holds the Cyan color at the end */}
                <rect
                    className="knob-right"
                    x="15" y="10" width="6" height="4" rx="1.5"
                    fill={c.primary}
                    stroke={variant === 'active' ? c.accent : 'transparent'}
                    strokeWidth="1.2"
                />

                {/* Shared Content Dots (Anchor points for the set) */}
                <circle cx="7.5" cy="7.5" r="1" fill="currentColor" opacity="0.4" />
                <circle cx="7.5" cy="16.5" r="1" fill="currentColor" opacity="0.4" />
                <circle cx="16.5" cy="16.5" r="1" fill="currentColor" opacity="0.4" />

                {/* Accent dot for active state */}
                {variant === 'active' && (
                    <circle cx="19" cy="6" r="2" fill={c.accent} />
                )}
            </svg>
        </>
    )
}